import "./App.css";
import React from "react";

import RequireAuth from "./components/RequireAuth";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";

import useAuth from "./hooks/useAuth";

import Home from "./pages/Home";
import Employees from "./pages/Employees";
import Gasto from "./pages/Gasto";
import Menu from "./pages/Menu";
import ReportDay from "./pages/ReportDay";
import Registros from "./pages/Registros";
import Sucursales from "./pages/Sucursales";
import LogIn from "./pages/LogIn";
import Usuarios from "./pages/Usuarios";
import ProductsN from "./pages/ProductsNegocios";

import Cierres from "./pages/Cierres";
import Turnos from "./pages/Turnos";
import Overview from "./pages/Overview";
import Dashboard from "./pages/Dashboard";
import Venta from "./pages/Venta";
import Billeteras from "./pages/Billeteras";
import MovimientosBilleteras from "./pages/MovimientosBilleteras";
import GastoNegocios from "./pages/GastoNegocios";
import TicketsFab from "./fabrica-pages/TicketsFab";
import ProductosVendidos from "./fabrica-pages/ProductosVendidos";
import NegociosGastos from "./pages/NegociosOverview/negociosGastos";

import Prices from "./pages/Prices";
import PricesChangeAll from "./pages/PricesChangeAll";
import Retiros from "./pages/Retiros";

function App() {
  // const { auth } = useAuth();
  // const { setAuth } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* <Route path="/dashboard" element={<Dashboard />}> */}
        {/* <Route path="*" element={<Home />} /> */}
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<LogIn />} />

        {/* Private Routes */}
        <Route path="/gastofab" element={<Gasto />} />
        <Route path="/gastonegocios" element={<GastoNegocios />} />
        <Route path="/venta" element={<Venta />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/reportday" element={<ReportDay />} />
        <Route path="registros" element={<Registros />} />
        <Route path="turnos" element={<Turnos />} />
        <Route path="negociosgastos" element={<NegociosGastos />} />
        <Route path="ventasygastos" element={<Overview />} />
        <Route path="ticketsfab" element={<TicketsFab />} />
        <Route path="/productsales" element={<ProductsN />} />
        <Route path="productos" element={<ProductosVendidos />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cierres" element={<Cierres />} />
        <Route path="/billeteras" element={<Billeteras />} />
        <Route path="/billeterasoverview" element={<MovimientosBilleteras />} />
        <Route path="/retiros" element={<Retiros />} />

        {/* <Route path="/cierres" element={<Cierres />} /> */}
        {/* Admin Routes */}
        <Route element={<RequireAuth />}>
          <Route path="/sucursales" element={<Sucursales />} />
          <Route path="/usuarios" element={<Usuarios />} />
          <Route path="/precios" element={<Prices />} />
          <Route path="/preciosall" element={<PricesChangeAll />} />
        </Route>
      </Route>
      <Route path="*" element={<h1>Not Found</h1>} />
    </Routes>
  );
}

export default App;
